import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import ImpactStats from './components/ImpactStats';
import FeaturedStories from './components/FeaturedStories';
import CategoryChannels from './components/CategoryChannels';
import NewsletterCTA from './components/NewsletterCTA';
import OrganizationSchema from '@/components/base/OrganizationSchema';
import BreadcrumbListSchema from '@/components/base/BreadcrumbListSchema';
import WebPageSchema from '@/components/base/WebPageSchema';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebPageSchema
        url="http://cg91.cn/"
        name="The Vertex — Independent Journalism for the Curious Mind"
        description="The Vertex delivers in-depth journalism at the intersection of technology, business, design, and culture. Independent, reader-supported reporting with no paywalls."
        dateModified="2026-07-07"
      />
      <BreadcrumbListSchema
        items={[
          { name: 'Home', url: 'http://cg91.cn/' },
        ]}
      />
      <main className="min-h-screen bg-background-50 font-body">
        <Navbar />
        <Hero />
        <ImpactStats />
        <FeaturedStories />
        <CategoryChannels />
        <NewsletterCTA />
        <Footer />
      </main>
    </>
  );
}